import { useEffect } from 'react';
import { getCurrentHouseholdMember } from '../utils/householdMember/getCurrentHouseholdMember';
import { preventerTools } from '../utils/tools/preventerTools';
import { localStorageHyperDashboardTools } from '../utils/tools/localStorageHyperDashboardTools';
import { configs } from '../constants/configs/configs';

export const useMockModal = config => {

    const {
        adjustedFlow,
        page,
        data,
        fetchMockModal
    } = config;

    useEffect(
        () => {
            const {
                hhmIndex = null
            } = adjustedFlow[page] ? getCurrentHouseholdMember(adjustedFlow, page, preventerTools.provideArray(data.taxHousehold.householdMember)) : {};

            const mockModalType = localStorageHyperDashboardTools.getValueByPropName('modals', '');

            if(configs.ENV.DEVELOPMENT && data.taxHousehold.householdMember.length) {
                fetchMockModal(mockModalType, hhmIndex, data.taxHousehold.householdMember.length > 0);
            }
        }, 
        [ data.taxHousehold.householdMember.length ]
    );
};